import { render, staticRenderFns } from "./S12GameEntries.vue?vue&type=template&id=25a74b90&scoped=true"
import script from "./S12GameEntries.vue?vue&type=script&lang=js"
export * from "./S12GameEntries.vue?vue&type=script&lang=js"
import style0 from "./S12GameEntries.vue?vue&type=style&index=0&id=25a74b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a74b90",
  null
  
)

export default component.exports